import { startEntraLogin } from '../services/authService';
import { useLogout } from './useLogout';
import { useMe } from './useMe';

export function useAuth() {
  const meQuery = useMe();
  const logoutMutation = useLogout();

  return {
    user: meQuery.data ?? null,
    isAuthenticated: !!meQuery.data,
    isLoading: meQuery.isLoading,
    /** Redireciona o navegador para o login OIDC do back. */
    login: startEntraLogin,
    logout: logoutMutation.mutate,
    isLoggingOut: logoutMutation.isPending,
  };
}
